import { render, staticRenderFns } from "./gateways.vue?vue&type=template&id=47d638a0&scoped=true"
import script from "./gateways.vue?vue&type=script&lang=js"
export * from "./gateways.vue?vue&type=script&lang=js"
import style0 from "./gateways.vue?vue&type=style&index=0&id=47d638a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d638a0",
  null
  
)

export default component.exports